import React from 'react'
import RetailerCard from './RetailerCard'

const RetailerList = ({ retailers = [] }) => {
  if (retailers.length === 0) {
    return <div className="text-center text-gray-500 py-10">No items found.</div>
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {retailers.map((item, index) => (
        <RetailerCard key={item.id || index} retailer={item} />
      ))}
    </div>
  )
}

export default RetailerList
